import { render, staticRenderFns } from "./PartnershipTermsModal.vue?vue&type=template&id=086f9374&"
import script from "./PartnershipTermsModal.vue?vue&type=script&lang=js&"
export * from "./PartnershipTermsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports